<template>
  <el-dialog title="大包详情" :visible="visible" width="800px" :close-on-click-modal="false" @close="close">
    <div class="box" ref="box">
      <div class="content">
        <p>LP单号：{{ detailInfo.handoverContentCode || "--" }}</p>
        <p>运单号：{{ detailInfo.handoverOrderId || "--" }}</p>
        <p>预估重量（kg）：{{ detailInfo.weight || 0 }} kg</p>
        <p>申报件数：{{ detailInfo.quantity || 0 }}件</p>
      </div>

      <div class="btnBox">
        <el-button type="text" @click="print">打印（{{ detailInfo.printCount || 0 }}）</el-button>
        <el-button type="text" @click="weightEnter">总重录入</el-button>
      </div>

      <div class="list">
        <div class="title">
          <span>小包列表</span>
          <el-button type="danger" size="mini" @click="cancelBigPackage" :loading="cancelLoading"
            :disabled="cancelLoading">取消大包</el-button>
        </div>
        <el-dialog title="总重录入" :modal="false" :visible="weightVisible" width="25%" :close-on-click-modal="false"
          @close="weightClose">
          <div class="content">
            <div class="left">
              <el-form label-width="100px" ref="form" :model="form" :rules="formRules">
                <el-form-item label="重量" prop="weight">
                  <el-input v-model="form.weight" placeholder="重量">
                    <template slot="append">Kg</template>
                  </el-input>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="weightClose" :loading="submitLoading" :disabled="submitDisabled">取消</el-button>
            <el-button type="primary" @click="submit" :loading="submitLoading"
              :disabled="submitDisabled">确认录入</el-button>
          </span>
        </el-dialog>
        <el-table :data="tableData" border style="width: 100%" :header-cell-style="{ textAlign: 'center' }" row-key="id"
          height="250">
          <el-table-column label="图片" width="100" align="center">
            <template slot-scope="scope">
              <div class="details" style="display: flex; justify-content: center" v-for="item in scope.row.imageList"
                :key="item">
                <div class="details_left" style="display: flex; justify-content: center">
                  <el-popover trigger="hover" placement="right">
                    <img :src="item" alt />
                    <div class="scope_img" slot="reference">
                      <img :src="item" alt />
                    </div>
                  </el-popover>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="amazonOrderId" label="订单号" align="center"></el-table-column>

          <el-table-column prop="trackingNumber" label="运单号" align="center"></el-table-column>
          <el-table-column prop="weight" label="预估重量(kg)" width="150" align="center"></el-table-column>
        </el-table>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { ajaxPost, Baseurl } from "@/api/api/api";
export default {
  name: "bigPackageDetail",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    currentForm: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      loading: true,
      detailInfo: {},
      tableData: [],
      cancelLoading: false,
      weightVisible: false,
      submitLoading: false,
      submitDisabled: false,
      form: {
        weight: undefined, //重量
      },
      formRules: {
        weight: [
          { required: true, message: "请输入重量", trigger: "change" },
          { validator: this.checkWeight, trigger: "change" },
        ],
      },
    };
  },
  mounted() {
    if (this.currentForm.id) {
      this.getDetail();
    }
  },
  methods: {
    checkWeight(rule, value, callback) {
      if (isNaN(value)) {
        callback("请输入数字格式");
        return;
      }
      callback();
    },
    weightClose() {
      this.weightVisible = false
      this.form.weight = null
    },
    // 提交
    submit() {
      console.log(this.currentForm);

      const API =
        Baseurl + "aliexpressParcel/updateHandoverGrossWeight";
      this.submitDisabled = true;
      this.submitLoading = true;
      const sendData = {
        id: this.currentForm.id,
        grossWeight: this.form.weight,
        rid: JSON.parse(localStorage.getItem('role')).rid,
        handoverOrderId: this.currentForm.handoverOrderId
      };
      ajaxPost(API, sendData)
        .then((res) => {
          const { code, data } = res.data;
          if (code === 200) {
            this.$message.success("录入成功!");
            this.weightVisible = false
          } else {
          }
          this.submitDisabled = false;
          this.submitLoading = false;
        })
        .catch(() => {
          this.submitDisabled = false;
          this.submitLoading = false;
        });
    },
    // 总包录入打开
    weightEnter() {
      this.weightVisible = true
    },
    getDetail() {
      let API = Baseurl + "aliexpressParcel/selectHandoverDetails";
      const sendData = { id: this.currentForm.id };
      const loading = this.$loading({
        target: this.$refs.box,
        text: "努力加载中...",
        background: "rgba(218,218,238,0.2)",
      });
      ajaxPost(API, sendData)
        .then((res) => {
          const { code, data } = res.data;
          if (code === 200) {
            this.detailInfo = data || {};
            this.tableData = this.detailInfo?.aliexpressParcelList || [];
            loading.close();
          } else {
            this.$message.error(res.data);
          }
        })
        .catch(() => {
          this.$message.error("操作失败");
        });
    },
    print() {
      if (this.detailInfo.url) {
        window.open(this.detailInfo.url, "_blank");
        this.updatePrimtNum();
      } else {
        const API = Baseurl + "aliexpressParcel/getHandoverPdf";
        const sendData = {
          sellerId: this.detailInfo.sellerId,
          handoverContentId: this.detailInfo.handoverContentId,
        };
        ajaxPost(API, sendData).then((res) => {
          const { code, data } = res.data;
          if (code === 200) {
            window.open(data, "_blank");
            this.updatePrimtNum();
          } else {
            this.$message.error(data);
          }
        });
      }
    },
    //更新打印次数
    updatePrimtNum() {
      const API = Baseurl + "aliexpressParcel/updateHandoverPrintCount";
      const sendData = {
        id: this.currentForm.id,
      };
      ajaxPost(API, sendData).then((res) => {
        if (res.data.code === 200) {
          this.getDetail();
        }
      });
    },
    //取消大包
    cancelBigPackage() {
      this.$confirm("是否取消大包?", "取消大包", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.cancelBigPackageFn();
        })
        .catch(() => { });
    },
    cancelBigPackageFn() {
      const API = Baseurl + "aliexpressParcel/cancelHandover";
      const { id, sellerId, handoverOrderId, handoverContentId } =
        this.currentForm;
      const sendData = {
        id,
        sellerId,
        handoverOrderId,
        handoverContentId,
      };
      this.cancelLoading = true;
      ajaxPost(API, sendData)
        .then((res) => {
          const { code, data } = res.data;
          if (code === 200) {
            this.$message.success("取消成功");
            this.$emit("updateList");
            this.close();
          } else {
            this.$message.error(`取消失败:${data}`);
          }
          this.cancelLoading = false;
        })
        .cathc(() => {
          this.cancelLoading = false;
        });
    },
    close() {
      this.$emit("cancelVisible");
    },
  },
};
</script>
<style lang="scss" scoped>
div.content {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;

  p {
    width: calc(50% - 12px);
    line-height: 32px;
  }
}

.scope_img {
  width: 55px;
  height: 55px;

  img {
    width: 100%;
    height: 100%;
  }
}

.prduct_img {
  width: 500px;
  height: 500px;
}

.cell {
  display: flex;
  justify-content: center;
  align-items: center;

  .scope_img {
    display: initial;
  }

  .scope_img img {
    width: 55px;
    height: 55px;
  }
}

.details {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.details_left {
  width: 30%;
  text-align: center;
}

.details_right {
  width: 70%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.btnBox {
  display: flex;
  justify-content: flex-end;
}

div.list {
  div.title {
    display: flex;
    gap: 24px;
    align-items: center;
    margin-bottom: 16px;

    >span {
      font-size: 16px;
    }
  }
}
</style>
